import { Button, Card, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { FormProvider } from "react-hook-form";

import { AdminMenuLayout, ModalDiscountCode } from "../../../shared/components";
import { selectModalDiscountCode } from "../../../redux/selectors/discountCode.selectors";
import { useDiscountCode } from "../hooks";
import { TableDiscountCode } from "./TableDiscountCode";

export const DiscountCode = () => {
  const modalDiscountCode = useSelector(selectModalDiscountCode);

  const {
    isUpdateDiscountCode,
    formMethodsCreate,
    formMethodsUpdate,
    changeModalDiscountCodeState,
  } = useDiscountCode();

  return (
    <AdminMenuLayout pageDescription="Cupones" title="Cupones">
      <Card
        bodyStyle={{ padding: "24px", display: "block" }}
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <div
          style={{
            marginBottom: 24,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            borderBottom: "1px solid #f0f0f0",
            paddingBottom: 16,
          }}
        >
          <div>
            <h2
              style={{
                fontSize: 20,
                fontWeight: 600,
                margin: 0,
                color: "#262626",
              }}
            >
              Cupones de descuento
            </h2>
            <p style={{ margin: "6px 0 0", color: "#8c8c8c", fontSize: 14 }}>
              Crea y administra códigos promocionales para la app.
            </p>
          </div>

          <Space size={12}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              size="large"
              onClick={changeModalDiscountCodeState}
              style={{
                borderRadius: "30px",
                fontWeight: 600,
                padding: "0 24px",
                height: 44,
                boxShadow: "0 4px 10px rgba(233, 87, 53, 0.3)",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              Nuevo cupón
            </Button>
          </Space>
        </div>

        <TableDiscountCode />

        {modalDiscountCode && isUpdateDiscountCode && (
          <FormProvider {...formMethodsUpdate}>
            <ModalDiscountCode />
          </FormProvider>
        )}
        {modalDiscountCode && !isUpdateDiscountCode && (
          <FormProvider {...formMethodsCreate}>
            <ModalDiscountCode />
          </FormProvider>
        )}
      </Card>
    </AdminMenuLayout>
  );
};
